@if (displayForm) {

@if (message) {
<div class="message-container solid-red-fill text-centered mb-4">
  <div [innerHTML]="message | pipeSafeHTML"></div>
</div>
}

<div class="content-container">
  <div class="title">
      <mwp-text-translate text="MEMBER CONFIRMATION" jsonKey="memberConfirmation" />
    </div>
  <div class="content px-0">
    <div class="sub-title">
      <mwp-text-translate text="Please verify or enter a valid email address for this user:" jsonKey="memberConfirmNote" />
    </div>
    <form [formGroup]="confirmForm">
      <div class="d-flex flex-wrap">
        <div class="w-20 p-3">
          <mwp-input [form]="confirmForm" labelName="SSN" nameForControl="ssn" disabled=true />
        </div>
        <div class="w-20 p-3">
          <mwp-input [form]="confirmForm" labelName="Name" nameForControl="memberName" disabled="true" />
        </div>
        <div class="w-20 p-3">
          <mwp-input [form]="confirmForm" labelName="Company" nameForControl="companyName" disabled="true" />
        </div>
        <div class="w-20 p-3">
          <mwp-input [form]="confirmForm" labelName="Birth Date" nameForControl="birthDate" disabled="true" />
        </div>
        <div class="w-20 p-3">
          <mwp-input [form]="confirmForm" labelName="SID" nameForControl="systemNumber" disabled="true" />
        </div>
        <div class="w-20 p-3">
          <mwp-input [form]="confirmForm" labelName="Home Email" nameForControl="email" />
        </div>
        <div class="w-20 p-3">
          <mwp-input [form]="confirmForm" labelName="Phone" nameForControl="phone" [maskType]="maskType.phone" />
        </div>
        @for (detail of details; track detail) {
        <div class="w-20 p-3">
          <mat-form-field appearance="outline">
            <mat-label>
              <mwp-text-translate [text]="detail.text" [jsonKey]="detail.text" />
            </mat-label>
            <input matInput value="{{ detail.value }}" disabled="true">
          </mat-form-field>
        </div>
        }
      </div>
    </form>
    @if (displayForm) {
    <div class="d-inline-flex w-100 justify-content-end my-3">
      <button class="mwp-button-secondary me-3" (click)="back()">
        <mwp-text-translate text="Back" jsonKey="back" />
      </button>
      <button class="mwp-button me-3" [disabled]="!confirmForm.valid" (click)="confirmMember()">
        <mwp-text-translate text="Continue" jsonKey="continue" />
      </button>
    </div> }
  </div>
</div>

}